export default __webpack_public_path__ + "static/media/too-many-works-tablet.8a4025db.png";